<template>
  <SSettingsProfile
    :firstLetters="getFirstLetters"
    :userDetailsForBookingDetails="getUserDetailsForBookingDetails"
    @setGlobalLoading="setGlobalLoading"
    @populateUserProfileInfo="populateUserProfileInfo"
  />
</template>

<script lang="ts">
export default {
  name: 'SettingsProfile',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { SSettingsProfile } from '@slg/web-customer-shared';
import { useStore, useGlobalErrorDialog } from '@/composables';

const store = useStore();
const { setGlobalError } = useGlobalErrorDialog();

const getUserDetailsForBookingDetails = computed(() => store.getters['auth/getUserDetailsForBookingDetails']);
const getFirstLetters = computed(() => store.getters['auth/getFirstLetters']);

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}
</script>
